const cardStyles = theme => ({
  card: {
    padding: "0px 12px"
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    padding: "0px 0px",
    fontSize: "16px"
  },
  label: {
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: "10px"
  },
  value: {
    flexGrow: "1",
    color: theme.palette.black
  }
});

export default cardStyles;
